var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 8C15.3333 12.0501 12.0501 15.3333 8 15.3333C3.94991 15.3333 0.666667 12.0501 0.666667 8C0.666667 3.94991 3.94991 0.666667 8 0.666667C12.0501 0.666667 15.3333 3.94991 15.3333 8Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24168 9.55273C6.1331 9.55273 4.33203 9.88518 4.33203 11.215C4.33203 12.5452 6.12185 12.8894 8.24168 12.8894C10.3503 12.8894 12.1513 12.5574 12.1513 11.2272C12.1513 9.89691 10.362 9.55273 8.24168 9.55273Z",
    fill: "#58A6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24345 8.28573C9.67981 8.28573 10.8307 7.1344 10.8307 5.69853C10.8307 4.26266 9.67981 3.11133 8.24345 3.11133C6.80758 3.11133 5.65625 4.26266 5.65625 5.69853C5.65625 7.1344 6.80758 8.28573 8.24345 8.28573Z",
    fill: "#CFE6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerType);
export default __webpack_public_path__ + "static/media/customer_type.fd748d9925c8d40555ac539043e5500f.svg";
export { ForwardRef as ReactComponent };